import { BadgeProps, tokens } from "@blurb/codex-react";
import { reportUnrecognizedStatus, type StatusKind } from "../../utils/unrecognizedStatus";

export type StatusBadgeColor = NonNullable<BadgeProps["color"]>;

export type StatusBadgeDisplay = {
  name: string;
  color: StatusBadgeColor;
};

const ICON_COLOR: Record<StatusBadgeColor, string> = {
  blue: tokens.color.primitive.light.blue[700],
  purple: tokens.color.primitive.light.purple[700],
  green: tokens.color.primitive.light.green[700],
  orange: tokens.color.primitive.light.yellow[800],
  red: tokens.color.primitive.light.red[700],
  white: tokens.color.primitive.light.gray[900],
  gray: tokens.color.primitive.light.gray[700],
};

/** Token icon color matching a Badge semantic color. */
export function statusBadgeIconColor(color: StatusBadgeColor): string {
  return ICON_COLOR[color];
}

// Resolves the badge for a status, falling back to a neutral gray badge (labeled with the raw value)
// for a status this build doesn't know — e.g. one the backend adds after this bundle ships — so the
// cell renders instead of crashing. Reports the gap to RUM (deduped); `kind` labels it there.
export function resolveStatusBadge<T extends string>(
  config: Record<T, StatusBadgeDisplay>,
  kind: StatusKind,
  status: T
): StatusBadgeDisplay {
  const known: StatusBadgeDisplay | undefined = config[status];
  if (known !== undefined) return known;
  reportUnrecognizedStatus(kind, status);
  return { name: status, color: "gray" };
}
